import FrameBorder from '@/component/FrameBorder';
import PopupFrame from '@/component/popups/ui-1';
import Treasure from '@/component/popups/ui-2/Treasure';
import { getShweVaultStatus, postShweVaultOpen } from '@/Redux/futures/ShweVault/actions';
import { formatDataNumberToen } from '@/utils/helper';
import btnOpenVault from '@assets/web-v3-images/btn-Revive.png';
import backgroundImg from '@assets/web-v3-images/FrameBorder.png';
import noPiecesImg from '@assets/web-v3-images/not-lowest-unique.png';
import gotItImg from '@assets/web-v3-images/btn-login.png';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import ProgressVault from '../ProgressVault';

export default function OpenVault({ value, setValue, selectedState, setSelectedState, data }) {
	const dispatch = useDispatch();
	const { t } = useTranslation()
	const [disable, setDisable] = useState(false)
	const [openResult, setOpenResult] = useState(false)
	const [openNoPieces, setOpenNoPieces] = useState(false)
	const [valueResult, setValueResult] = useState('')

	const getVaultMessage = (data) => {
		const messages = {
			EXPLORER: {
				1: t("shwe_vault.1_mytel_loyalty_points").replace("_LP_", formatDataNumberToen(data?.reward_lp)),
				2: t("shwe_vault.2_mytel_loyalty_points").replace("_LP_", formatDataNumberToen(data?.reward_lp)),
				3: t("shwe_vault.3_mytel_loyalty_points").replace("_LP_", formatDataNumberToen(data?.reward_lp)),
				4: t("shwe_vault.4_mytel_loyalty_points").replace("_LP_", formatDataNumberToen(data?.reward_lp)),
			},
			MASTER: {
				1: t("shwe_vault.1_mytel_loyalty_points_Master").replace("_LP_", formatDataNumberToen(data?.reward_lp)),
				2: t("shwe_vault.2_mytel_loyalty_points_Master").replace("_LP_", formatDataNumberToen(data?.reward_lp)),
				3: t("shwe_vault.3_mytel_loyalty_points_Master").replace("_LP_", formatDataNumberToen(data?.reward_lp)),
				4: t("shwe_vault.4_mytel_loyalty_points_Master").replace("_LP_", formatDataNumberToen(data?.reward_lp)),
			},
		};
		return messages[data?.rank_snapshot]?.[data?.vault_order] || "";
	};

	const callbackShweVaultOpen = (data, isLoading, dataError) => {
		if (dataError?.showType === 2) {
			setOpenNoPieces(true)
			return;
		}

		if (data) {
			setOpenResult(true)
			setValueResult(data?.data || {})
			dispatch(getShweVaultStatus({}));
		}
	};

	const handleOpenVault = () => {
		if (disable) return;

		const body = {
			callback: callbackShweVaultOpen,
		};
		dispatch(postShweVaultOpen(body));
	}

	useEffect(() => { // check để disable button
		const vaults = data?.vaults;
		const pieceBalance = data?.piece_balance ?? 0;

		const hasAvailable = vaults?.some(item => item?.state === "Available");
		const allCompleted = vaults?.length > 0 && vaults?.every(item => item?.state === "Completed");

		const availableVault = vaults?.find(item => item?.state === "Available");
		const notEnoughPiece = availableVault ? pieceBalance < availableVault.piece_required : false;

		setDisable(!hasAvailable || allCompleted || notEnoughPiece || selectedState === "Completed" || selectedState === "Locked");
	}, [data?.vaults, data?.piece_balance, selectedState]);

	return (
		<div className='pt-[3%]'>
			<FrameBorder>
				<div
					className="w-full bg-cover bg-no-repeat "
					style={{
						backgroundImage: `url(${backgroundImg})`,
						backgroundSize: "100% auto",
						backgroundRepeat: "no-repeat",
						backgroundPosition: "top center",
					}}
				>
					<ProgressVault
						setValue={setValue}
						value={value}
						setSelectedState={setSelectedState}
						data={data}
					/>
					<div className="p-2 sm:p-2 md:p-2 lg:p-6 xl:p-6 pt-0 ">
						<button
							disabled={disable}
							className={`relative w-full cursor-pointer btn-click-active outline-none
							${disable && "opacity-30 cursor-not-allowed pointer-events-none"}`}
							onClick={handleOpenVault}
						>
							<img
								src={btnOpenVault}
								alt="Open Vault"
								className="block w-full h-auto"
							/>

							<span
								className="absolute inset-0 flex items-center justify-center 
									text-[15px] sm:text-3xl font-bold text-white"
								style={{
									WebkitTextStroke: "4px #D86B00",
									paintOrder: "stroke fill",
								}}
							>
								{t('shwe_vault.open_vault')}
							</span>
						</button>
					</div>
				</div>
			</FrameBorder>

			{/* show khi nhận giải */}
			<Treasure
				open={openResult}
				onOpenChange={setOpenResult}
				handleClick={() => setOpenResult(false)}
				type={valueResult?.vault_order}
				valueCoin={formatDataNumberToen(valueResult?.reward_lp)}
				textDescribe={[getVaultMessage(valueResult)]}
				textBtn={t('shwe_vault.ok')}
				title={t('rank.congratulation')}
			/>

			{/* show khi không đủ mảnh để đổi */}
			<PopupFrame
				title={t('shwe_vault.not_enough_pieces')}
				open={openNoPieces}
				onOpenChange={setOpenNoPieces}
			>
				<div className='flex flex-col justify-between items-center sm:px-[13%]'>
					<img src={noPiecesImg} alt="NoPieces" className='pt-4 w-full max-w-[80%]' />
					<p className='text-[rgba(161,92,7,1)] text-[15px] sm:text-[20px] font-medium pt-4'>{t('shwe_vault.you_dont_have_enough_puzzle_pieces')}</p>
					<div className="pt-4">
						<button
							className={`relative w-full cursor-pointer btn-click-active outline-none		
							${disable && "opacity-30 cursor-not-allowed pointer-events-none"}`}
							onClick={() => setOpenNoPieces(false)}
						>
							<img
								src={gotItImg}
								alt="Open Vault"
								className="block w-full h-auto"
							/>

							<span
								className="absolute inset-0 flex items-center justify-center 
									text-lg sm:text-2xl
									font-bold text-white"
							>
								{t('shwe_vault.got_it')}
							</span>
						</button>
					</div>
				</div>
			</PopupFrame>
		</div>
	)
}
